import { atom } from "recoil";
import { CreateCampaignStepIRoute } from "../generated/Api";
import { Campaign, CampaignFilters } from "../types/CampaignTypes";

export const ActiveCampaignAtom = atom<Campaign | null>({
  key: "ActiveCampaignAtom",
  default: null,
});

export const TempCampaignAtom = atom<Campaign | null>({
  key: "TempCampaignAtom",
  default: null,
});

export const DEPRECATED__AllCampaignsAtom = atom<Campaign[] | null>({
  key: "AllCampaignAtom",
  default: [],
});

export const CampaignFilterAtom = atom<CampaignFilters>({
  key: "CampaignFilterAtom",
  default: {
    limit: 25,
    orderBy: "name",
    orderByOrientation: 1,
  },
});

export const FilteredCampaignsAtom = atom<Campaign[] | null>({
  key: "FilteredCampaignsAtom",
  default: null,
});

export const ContactCampaignStepsAtom = atom<CreateCampaignStepIRoute[]>({
  key: "ContactCampaignSteps",
  default: [],
});

export const SearchCampaignAtom = atom<string>({
  key: "SearchCampaignAtom",
  default: "",
});
